import React, { useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Divider, Card, CardText, Paper } from 'material-ui';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';

import { get } from 'lodash';
import PanelMessage from 'components/panels/PanelMessage';
import KTitle from 'components/KJRN/KTitle';
import KValue from 'components/KJRN/KValue';
import styles from 'styles/HolidayEntry';
import KFlatButton from './KJRN/KFlatButton';
import HolidayOverview from './HolidayOverview';
import TLoading from '../containers/tiles/TLoading';

const loadingStyle = {
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'center',
  marginBottom: 16,
  marginTop: '40px',
  padding: 16,
};

const HolidayEntry = (props) => {
  const [expanded, setExpanded] = useState(true);

  const toggleExpanded = () => {
    setExpanded(!expanded);
  };

  const {
    FirstOfMai,
    Sum,
    Taken,
    WorkTimePerDay,
    showByHour,
    Overview,
    holidayInfo,
    earnedHolidayInfo,
    fetchingByYear,
    selectedYear,
  } = props;
  const earnedHolidayYear = get(earnedHolidayInfo, 'PayWageCollectYear');
  const allowance = get(earnedHolidayInfo, 'allowance');
  const earned = get(earnedHolidayInfo, 'Earned', 0);
  const earnedWorkTimePerDay = get(earnedHolidayInfo, 'WorkTimePerDay', 0);

  let holidayLeft = 0;
  if (FirstOfMai > Taken) {
    holidayLeft = (1 - (Taken / FirstOfMai)) * 100;
  }

  let holidayCollected = 0;
  if (allowance > earned) {
    holidayCollected = (earned / allowance) * 100;
  }

  let divider = WorkTimePerDay;
  let earnedDivider = earnedWorkTimePerDay;
  let formatId = 'holiday.days';
  if (showByHour) {
    divider = 1;
    earnedDivider = 1;
    formatId = 'holiday.hours';
  }

  return (
    <div style={styles.container}>
      <div style={styles.containerItem}>
        <KTitle
          containerStyle={{ marginBottom: 18 }}
          subtitleStyle={styles.subtitle}
          style={styles.title}
          title={
            <FormattedMessage
              id="holiday.title.year"
              values={{ year: selectedYear }}
            />
            }
          subtitle={<FormattedMessage
            id="tile.holiday.period"
            values={{ year: selectedYear, nextYear: selectedYear + 1 }}
          />}
        />
        {fetchingByYear ? (
          <TLoading />
        ) : (
          <div>
            {FirstOfMai === undefined ? (
              <PanelMessage
                type="info"
                iconName="info"
                message={<FormattedMessage id="tile.holiday.empty" />}
              />
            ) : (
              <Card expanded={expanded} style={{ padding: 16, border: 'none', boxShadow: 'none' }}>
                <div style={styles.mainValueContainer}>
                  <KValue
                    valueStyle={styles.mainValue}
                    value={
                      <FormattedMessage
                        id={formatId}
                        values={{ val: (Sum / divider).toLocaleString('de', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
                      />
                }
                    label={<FormattedMessage id="tile.holiday.sum" />}
                  />
                  <div style={styles.chart}>
                    <div style={{ ...styles.chartBar, width: `${holidayLeft}%` }} />
                  </div>
                </div>
                <div />
                <Divider />
                <div style={styles.valueContainer}>
                  <KValue
                    value={
                      <FormattedMessage
                        id={formatId}
                        values={{ val: (FirstOfMai / divider).toLocaleString('de', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
                      />
                }
                    label={<FormattedMessage id="tile.holiday.firstOfMay" values={{ year: selectedYear }} />}
                  />
                  <KValue
                    value={
                      <FormattedMessage
                        id={formatId}
                        values={{ val: (Taken / divider).toLocaleString('de', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
                      />
                }
                    label={
                      <FormattedMessage id="tile.holiday.taken" values={{ year: selectedYear }} />
                }
                  />
                </div>
                <KFlatButton
                  style={styles.actionButton}
                  containerStyle={styles.action}
                  label={<FormattedMessage id="holiday.usedVacation" />}
                  onClick={toggleExpanded}
                  iconName={expanded ? 'expand_less' : 'expand_more'}
                />
                <CardText expandable>
                  <HolidayOverview overview={Overview} divider={divider} />
                </CardText>
              </Card>)}
          </div>
      )}
      </div>
      <div style={styles.containerItem}>
        <KTitle
          style={styles.title}
          containerStyle={{ marginBottom: 18 }}
          subtitleStyle={styles.subtitle}
          title={(
            <FormattedMessage
              id="holiday.title.year"
              values={{ year: earnedHolidayYear + 1 }}
            />
          )}
          subtitle={<FormattedMessage
            id="tile.holiday.period"
            values={{ year: earnedHolidayYear + 1, nextYear: earnedHolidayYear + 2 }}
          />}
        />
        <Paper zDepth={0} style={styles.paper}>
          <div style={styles.mainValueContainer}>
            <KValue
              valueStyle={styles.mainValue}
              value={
                <FormattedMessage
                  id={formatId}
                  values={{ val: (earned / earnedDivider).toLocaleString('de', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
                />
                }
              label={
                <FormattedMessage id="tile.holiday.earned1" values={{ year: earnedHolidayYear + 1 }} />
                }
            />
            <div style={styles.chart}>
              <div style={{ ...styles.chartBar, width: `${holidayCollected}%` }} />
            </div>
          </div>
          <Divider />
          <div style={styles.valueContainer}>
            <KValue
              value={
                <FormattedMessage
                  id={formatId}
                  values={{ val: (allowance / earnedDivider).toLocaleString('de', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
                />
                }
              label={
                <FormattedMessage id="tile.holiday.allowance" />
                }
            />
            <KValue
              value={
                <FormattedMessage
                  id="holiday.hours"
                  values={{ val: earnedWorkTimePerDay.toLocaleString('de', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
                />
                }
              label={
                <FormattedMessage id="tile.holiday.workTime" />
                }
            />
          </div>
        </Paper>
        {holidayInfo &&
        <Paper style={loadingStyle}>
          <div dangerouslySetInnerHTML={{ __html: holidayInfo.TextBody }} />
        </Paper>
          }
      </div>
    </div>
  );
};

HolidayEntry.propTypes = {
  FirstOfMai: PropTypes.number,
  Sum: PropTypes.number,
  Taken: PropTypes.number,
  WorkTimePerDay: PropTypes.number,
  showByHour: PropTypes.bool,
  Overview: PropTypes.object.isRequired,
  holidayInfo: PropTypes.object,
  earnedHolidayInfo: PropTypes.object,
  fetchingByYear: PropTypes.bool.isRequired,
  selectedYear: PropTypes.number.isRequired,
};

HolidayEntry.defaultProps = {
  Sum: 0,
};

const mapStateToProps = ({ EmployeeHolidayReducer }) =>
  ({
    holidayInfo: EmployeeHolidayReducer.holidayInfo,
  });

export default connect(mapStateToProps)(HolidayEntry);



// WEBPACK FOOTER //
// ./src/components/HolidayEntry.js